import api from './api';
import type { InventoryBalance } from '../types/venue';

const base = (venueId: string) => `/admin/venue/${venueId}/inventory/balance`;

const inventoryBalanceService = {
  /**
   * Get current balance for a single inventory item.
   * InventoryBalance is a derived read model — never written directly.
   * lastCost is display/cache only; real cost history is in InventoryMovement.
   * TODO Phase 6.
   */
  getBalance: async (
    venueId: string,
    inventoryItemId: string
  ): Promise<InventoryBalance> => {
    const response = await api.get(`${base(venueId)}/${inventoryItemId}`);
    return response.data;
  },

  /**
   * Get balances for all inventory items at a venue, optionally filtered by location.
   * Typically returned as a map keyed by inventoryItemId for O(1) lookups in the UI.
   * TODO Phase 6.
   */
  getBalances: async (
    venueId: string,
    locationId?: string
  ): Promise<Record<string, InventoryBalance>> => {
    const params: Record<string, unknown> = {};
    if (locationId) params.locationId = locationId;
    const response = await api.get(base(venueId), { params });
    return response.data;
  },

  /**
   * Recompute the cached balance for one item by summing its movement ledger.
   * Does NOT modify movements. Returns before/after/difference.
   */
  recomputeBalance: async (
    venueId: string,
    itemId: string,
  ): Promise<{ before: number; after: number; difference: number }> => {
    const response = await api.post(
      `/admin/venue/${venueId}/inventory/item/${itemId}/recompute-balance`,
    );
    return response.data;
  },
};

export default inventoryBalanceService;
